"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgChannelTelegram = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var SvgChannelTelegram = function SvgChannelTelegram(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    fill: "url(#sc_t__paint0_linear)",
    d: "M0 0h120v120H0z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M82.58 33.015c-4.333 1.542-41.514 17.482-58.937 25.361-8.173 3.696-5.377 6.122-4.302 6.778 1.076.656 9.034 3.498 14.412 4.59 5.377 1.094 7.744-.874 9.464-2.186 1.721-1.311 19.144-13.554 26.457-18.146 7.314-4.59 4.302.656 3.012 1.968-.86 1.093-13.336 13.118-19.144 18.365-5.808 5.247-1.506 7.652 0 8.745 2.207 1.602 11.615 8.526 20.865 14.43 9.249 5.902 10.11-2.406 10.755-4.592.645-2.186 5.807-35.636 7.528-47.88 1.874-13.336-5.162-9.193-10.11-7.433z",
    fill: "#fff"
  }), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "sc_t__paint0_linear",
    x1: 60,
    y1: 0,
    x2: 60,
    y2: 120,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    stopColor: "#39AEEA"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: 1,
    stopColor: "#289AD2"
  }))));
};

exports.SvgChannelTelegram = SvgChannelTelegram;